import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';

@Component({
  selector: 'app-page-cart-request-success',
  templateUrl: './page-cart-request-success.component.html',
  styleUrls: ['./page-cart-request-success.component.scss'],
})
export class PageCartRequestSuccessComponent {
  count = 1;

  url = environment.url;
  constructor(private router: Router) {}

  inicio() {
    this.router.navigate(['/inicio']).then(() => {
      window.location.reload();
    });
  }
}
